import React from 'react';

const sequence = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M19.8333 1.16699L24.4999 5.83366L19.8333 10.5003"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.5 12.833V10.4997C3.5 9.262 3.99167 8.07501 4.86683 7.19984C5.742 6.32467 6.92899 5.83301 8.16667 5.83301H24.5"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.16667 26.8333L3.5 22.1667L8.16667 17.5"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24.5 15.167V17.5003C24.5 18.738 24.0083 19.925 23.1332 20.8002C22.258 21.6753 21.071 22.167 19.8333 22.167H3.5"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default sequence;
